module.exports = __webpack_public_path__ + "./docs/img/icon-events.7c922e0d0d1a7392ffde2843a5dba117.svg";